import {baseUrl} from "./defaults";
import { addTokenToHeaders } from './headers';
import {authStore} from "../api";
import {ReportInvestmentActive} from "./report/reports";

const axios = require("axios");


let headers = {
    'Content-Type': 'text/plain'
    // 'token': token,
};

const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        ...headers
    }
});

addTokenToHeaders();

function errorResponseHandler(error) {
    window.confirm('Token wygasł, wróć na stronę logowania');
    console.log(window.location)
    window.location.replace(window.location.origin + '/login')
}


// === DEFAULT ERROR CALLBACK FUNCTION FOR WHOLE APP (ADMIN+CLIENT) ===
axiosInstance.defaults.errorHandler = {
    errorCallbackFunction: errorResponseHandler
};

axiosInstance.interceptors.response.use(response => {
    return response?.data;
}, error => {
    if (error?.response?.status === 405) {
        axiosInstance.defaults.errorHandler.errorCallbackFunction(error);
    } else if (error?.response?.status === 403) {
        axiosInstance.defaults.errorHandler.errorToast(error);
    } else {
        axiosInstance.defaults.errorHandler.errorToast(error);
        throw new Error(error?.response?.data?.error || error, {cause:
            error?.response?.data});
    }
});

// === ROUTING GUARDS ===
const informAboutCancelRouting = (to) => {
    axiosInstance.defaults.cancelRouting.reportEdition(to);
};

async function guardRoute(to, from, next) {
    if (!authStore.data.isAuthenticated && !localStorage.getItem('token')) {
        return next('/login');
    }

    if (authStore.data.menuCategories.length === 0 && localStorage.getItem('token')) {
        try {
            const { GetLoggedUser } = await import('./user/user');
            const userResponse = await GetLoggedUser();
            authStore.data.menuCategories = userResponse?.menuCategories ?? [];
            authStore.data.isAuthenticated = true;
        } catch (e) {
            return next('/login');
        }
    }

    const routeCode = to.meta?.routeCode;
    if (routeCode) {
        const category = authStore.data.menuCategories.find(
            cat => cat.route_codes.includes(routeCode)
        );
        if (!category || !category.is_enabled) {
            return next('/403');
        }
    }

    if (to.name === 'Report' && !!to.params.id) {
        try {
            const response = await ReportInvestmentActive(to.params.id);
            if (!!response.active && response.active) {
                return next();
            }
            informAboutCancelRouting('/reports');
            return next(false);
        } catch (e) {
            informAboutCancelRouting('/reports');
            return next(false);
        }
    }

    return next();
}

export {axiosInstance, guardRoute};
